import React from "react";
import { TableRow, TableCell, Box, Typography, Avatar } from "@mui/material";
import SessionsActivityBar from "./SessionsActivityBar";

const projectColors = {
    SG: "#6A0DAD",
    PQ: "#1976d2",
    CB: "#d81b60"
};

const SessionsMemberDetailsRow = ({ detail, index, rowDetails, isMeView = false }) => {
    let counter = 0;
    for (let j = 0; j <= index; j++) {
        if (rowDetails[j].date) counter++;
    }

    // Function to get initials from name
    const getInitials = (name) => {
        if (!name) return '';
        const names = name.split(' ');
        let initials = names[0].substring(0, 1).toUpperCase();

        if (names.length > 1) {
            initials += names[names.length - 1].substring(0, 1).toUpperCase();
        }

        return initials;
    };

    return (
        <TableRow>
            <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'center' }}>
                {detail.date ? counter : ""}
            </TableCell>
            <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'left' }}>
                {detail.date || ""}
            </TableCell>
            {!isMeView && ( <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'left' }}>
                <Box display="flex" gap={1}>
                    <Avatar
                        src={detail.avatar} // Add avatar prop
                        sx={{
                            bgcolor: projectColors[detail.code],
                            width: 40,
                            height: 40,
                            fontSize: '13px',
                        }}
                    >
                        {!detail.avatar && (detail.code || getInitials(detail.name))}
                    </Avatar>
                    <Box>
                        <Typography fontWeight="bold">{detail.name}</Typography>
                        <Typography variant="body2" color="text.secondary">
                            {detail.desk}
                        </Typography>
                    </Box>
                </Box>
            </TableCell>)}
             <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'center' }}>
                    {detail.manualHours}
                  </TableCell> 
                  <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'center' }}>
                    {detail.started}
                  </TableCell>
                  <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'center' }}>
                    {detail.stopped}
                  </TableCell>
                  <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'center' }}>
                    {detail.duration} 
                  </TableCell>
            <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'center' }}>
                <SessionsActivityBar activity={detail.activity} />
            </TableCell> 
            <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'center' }}>
                <Typography color="primary">
                    {detail.notes || "-"}
                </Typography>
            </TableCell>
        </TableRow>
    );
};

export default SessionsMemberDetailsRow;